import { platform } from 'constants'
import React from 'react'

import { Box } from 'widgets/Box'
import { CoachItem } from 'widgets/CoachItem'
import { FlatList } from 'widgets/FlatList'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

import { useOtherMembers } from 'hooks/useOtherMembers'
import { useUser } from 'hooks/useUser'

import commonStyles from 'utils/styles/commonStyles'

import { Program } from 'types/program'
import { UserType } from 'types/user'

type OtherMembersProps = {
  program: Program
}

export const OtherMembers = ({ program, creator, members, isLoadingCreator, isLoadingMembers }) => {
  const haveMembers = members && members.length
  const isLoading = isLoadingCreator || isLoadingMembers

  return (
    <>
      <Title bold>Members</Title>
      {!haveMembers ? (
        <Box margin={{ bottom: 'lg' }}>
          <Text fontSize='sm' color='greyDark'>
            No member have joined this program yet
          </Text>
        </Box>
      ) : null}
      {!isLoading && haveMembers ? (
        <Box
          testID='OtherMembersRow'
          flexDirection={members && members.length > 0 ? 'row' : 'column'}
          justifyContent='flex-start'
          width='100%'
          padding={{ bottom: 'smd' }}
          style={platform.IS_WEB ? commonStyles.overflowScroll : undefined}
        >
          <FlatList<UserType>
            horizontal
            data={creator ? [creator, ...members] : members}
            loading={isLoading}
            renderItem={({ item: user }) => (
              <Box padding={{ bottom: 'smd' }}>
                <CoachItem isMember user={user} />
              </Box>
            )}
            keyExtractor={(user) => `EmergingCoaches-${user?.id}`}
            testID='EmergingCoachesList'
            noContentProps={{
              marginTop: 50,
              marginBottom: 50,
              message: 'No member have joined this program yet',
            }}
            contentContainerStyle={commonStyles.flexGrow}
          />
        </Box>
      ) : null}
    </>
  )
}
